/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S33_Item_3Inputs */

const es_privacy_policy_data_collected_s33_item_3 = /** @type {(inputs: Privacy_Policy_Data_Collected_S33_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeddings Vectoriales: representaciones numericas para busquedas semanticas (no reversibles)`)
};

const en_privacy_policy_data_collected_s33_item_3 = /** @type {(inputs: Privacy_Policy_Data_Collected_S33_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vector Embeddings: numerical representations for semantic search (non-reversible)`)
};

/**
* | output |
* | --- |
* | "Vector Embeddings: numerical representations for semantic search (non-reversible)" |
*
* @param {Privacy_Policy_Data_Collected_S33_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s33_item_3 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S33_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S33_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s33_item_3(inputs)
	return en_privacy_policy_data_collected_s33_item_3(inputs)
});
export { privacy_policy_data_collected_s33_item_3 as "privacy_policy.data_collected.s33_item_3" }